export const enum DatadogEvent {
    LibrarySelected = 'Libs-Selected',
    LibThumbColor = 'Libs-ThumbnailColor',
    LibThumbImage = 'Libs-ThumbnailImage',
    LibBulkDelete = 'Bulk-Delete',
    LibChangeCategory = 'Libs-ChangeCategory',
    ClipboardPaste = 'Paste from Clipboard',
    RightClickMenuOpen = 'Opened Right Click Menu',
    ResetPreview = 'Reset Whole Preview',
    ResetPreviewElements = 'Reset Design Element Only',
    CopyDsDimensions = 'Copy Dimension',
    PasteDsDimensions = 'Paste Dimension',
    CopyDsPosition = 'Copy Position',
    PasteDsPosition = 'Paste Position',
    CopyDsColorOptions = 'Copy Color Options',
    PasteDsColorOptions = 'Paste Color Options',
    RenameTemplate = 'renameTemplate'
}

export const fireDatadogLog = (logType: DatadogEvent) => {
    const datadogRum = window.DD_RUM;
    if (!datadogRum) return;
    datadogRum.addAction(logType);
};
